const ports = [443, 80];
const portIndex = window.location.protocol.indexOf("https") === 0 ? 0 : 1;
const port = ports[portIndex];
export const defaultConfig = {
    port: port,
    path: "/auth-api",
    url: "",
    secure: port === 443,
};
export const mailSlurpAPIKey = "87e08be600f1c563636954ec7fe0b4e16d8ac7c3c2c10c92c1ed39d1cf3b6002";
